import { useState } from "react";
import { toast } from "sonner";
import { post, errMsg } from "../lib/api";

export const useSubmitForm = (path, initial, successMsg) => {
  const [values, setValues] = useState(initial);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const bind = (name) => ({ name, value: values[name] ?? "", onChange: (e) => setValues((v) => ({ ...v, [name]: e.target.value })) });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await post(path, values);
      toast.success(successMsg);
      setValues(initial);
      setDone(true);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return { bind, submit, loading, done, setDone };
};
